module.exports = __webpack_public_path__ + "static/media/logout.a29d8c4f.svg";